import React from 'react';

interface PrePraxisBadgeProps {
  className?: string;
  variant?: 'white' | 'indigo' | 'current' | 'chalkboard';
  showLaurels?: boolean;
  showCap?: boolean;
}

export const PrePraxisBadge: React.FC<PrePraxisBadgeProps> = ({
  className = 'w-10 h-10',
  variant = 'current',
  showLaurels = true,
  showCap = true,
}) => {
  // Color configuration
  let strokeColor = 'currentColor';
  let fillColor = 'currentColor';
  let tasselColor = '#5eb7e8'; // sky-blue tassel accent matching brand

  if (variant === 'white') {
    strokeColor = '#ffffff';
    fillColor = '#ffffff';
    tasselColor = '#7dd3fc';
  } else if (variant === 'indigo') {
    strokeColor = '#4338ca';
    fillColor = '#4338ca';
    tasselColor = '#0284c7';
  } else if (variant === 'chalkboard') {
    strokeColor = '#ffffff';
    fillColor = '#ffffff';
    tasselColor = '#5eb7e8';
  }

  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="PrePraxis Certification Badge"
      role="img"
    >
      {/* 1. Laurel / Seed Accents on Left and Right (Optional for higher fidelity) */}
      {showLaurels && (
        <g opacity="0.95" fill={fillColor}>
          {/* Left Laurel Leaves */}
          <ellipse cx="14" cy="44" rx="5" ry="2.2" transform="rotate(-30 14 44)" />
          <ellipse cx="11" cy="54" rx="5" ry="2.2" transform="rotate(0 11 54)" />
          <ellipse cx="14" cy="64" rx="5" ry="2.2" transform="rotate(30 14 64)" />

          {/* Right Laurel Leaves */}
          <ellipse cx="86" cy="44" rx="5" ry="2.2" transform="rotate(30 86 44)" />
          <ellipse cx="89" cy="54" rx="5" ry="2.2" transform="rotate(0 89 54)" />
          <ellipse cx="86" cy="64" rx="5" ry="2.2" transform="rotate(-30 86 64)" />
        </g>
      )}

      {/* 2. Main Circular Seal Ring */}
      <circle
        cx="50"
        cy="54"
        r="28"
        stroke={strokeColor}
        strokeWidth="5"
        strokeLinecap="round"
        fill="none"
      />

      {/* 3. Bold Central Passing Checkmark */}
      <path
        d="M39 54.5 L46.8 62.5 L61.5 44"
        stroke={strokeColor}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* 4. Graduation Cap (Mortarboard) Atop the Circle */}
      {showCap && (
        <g>
          {/* Cap Diamond Crown */}
          <polygon
            points="50,15 71,24 50,33 29,24"
            fill={fillColor}
            stroke={strokeColor}
            strokeWidth="1.5"
            strokeLinejoin="round"
          />

          {/* Cap Lower Base / Skullcap Band */}
          <path
            d="M39 28.5 C42 34 58 34 61 28.5"
            fill="none"
            stroke={strokeColor}
            strokeWidth="3.5"
            strokeLinecap="round"
          />

          {/* Center Button */}
          <circle cx="50" cy="24" r="2" fill={tasselColor} />

          {/* Hanging Blue Tassel */}
          <path
            d="M51 24 C64 25 66 36 64 42"
            fill="none"
            stroke={tasselColor}
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          {/* Tassel Tip Bead */}
          <circle cx="64" cy="42" r="2.2" fill={tasselColor} />
        </g>
      )}
    </svg>
  );
};
